import { Stack } from "@mui/material";
import { BusyButton } from "@gui/widgets/BusyButton";
import type { PageAction, PageBottomToolbarConfig } from "./PageLayout.types";

const actionKey = (action: PageAction, index: number) => action.id ?? `${index}-${action.label}`;

/**
 * The bottom toolbar's buttons, right-aligned: secondary actions `outlined`, the primary `contained`,
 * at normal size, the same as the top toolbar's (docs/design-system.md §4). Unlike the top toolbar there
 * is no ⋯ menu on a phone: a commit step has one or two buttons, and both must stay visible.
 */
export function PageBottomToolbar(props: { config: PageBottomToolbarConfig }) {
	const actions = props.config.actions ?? [];
	const primary = props.config.primaryAction;
	return (
		<Stack
			direction="row"
			spacing={1}
			useFlexGap
			justifyContent="flex-end"
			alignItems="center"
			sx={{ flexWrap: "wrap" }}
		>
			{actions.map((action, index) => (
				<BusyButton
					key={actionKey(action, index)}
					variant="outlined"
					startIcon={action.icon}
					onClick={action.onClick}
					disabled={action.disabled}
					busy={action.busy}
					busyLabel={action.busyLabel}
				>
					{action.label}
				</BusyButton>
			))}
			<BusyButton
				variant="contained"
				startIcon={primary.icon}
				onClick={primary.onClick}
				disabled={primary.disabled}
				busy={primary.busy}
				busyLabel={primary.busyLabel}
			>
				{primary.label}
			</BusyButton>
		</Stack>
	);
}
